module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_orebro-661920d397b6cc65e1af4e226894433e.png";